import { AlertTriangle } from 'lucide-react'
import { useTranslation } from 'react-i18next'

// Read at module load — Vite inlines the value at build time, so the
// banner is compiled out of production bundles where the flag is false.
// Exported so layouts can conditionally reserve bottom padding for the
// fixed strip without duplicating the env check.
export const DEMO_MODE = import.meta.env.VITE_DEMO_MODE === 'true'

/**
 * Persistent "demo environment, no real PHI" strip shown whenever the
 * app is built with VITE_DEMO_MODE=true (e.g. the
 * vynaemr-demo.flostel.com environment).
 *
 * Rendered as a **fixed bottom strip** rather than a top banner so it
 * doesn't steal vertical real estate from data-dense pages (Census,
 * MAR, worklists) while still staying visible regardless of scroll
 * position — the compliance intent is preserved, the cost to the
 * working surface drops from ~44px to ~24px.
 *
 * Not dismissible by design — users should not be able to forget
 * this is not a production EMR.
 */
export default function DemoBanner() {
  const { t } = useTranslation('common')

  if (!DEMO_MODE) return null

  return (
    <div
      role="alert"
      className="fixed inset-x-0 bottom-0 z-40 flex items-center justify-center gap-2 border-t border-amber-600/40 bg-amber-500/95 px-4 py-1 text-xs font-medium text-amber-950 backdrop-blur-xs"
    >
      <AlertTriangle className="h-3.5 w-3.5 shrink-0" aria-hidden="true" />
      <span>{t('demo.warning')}</span>
    </div>
  )
}
